import defaultHeaderImg from '@swf/components/StarsMPNotification/assets/images/default-chest-header.png';
import InstantBonusFront from '@swf/components/StarsMPNotification/components/InstantBonus/InstantBonus';
import InstantBonusBack from '@swf/components/StarsMPNotification/components/InstantBonus/InstantBonusBack';
import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { ActionType, FormatType } from '@swf/components/StarsMPNotification/enums';
import { dispatch } from '@swf/core/store';
import type { SplitWagerBonusMPNotification } from '@swf/core/types/Notification';

import {
  TXTCLI_Accept,
  TXTCLI_By_accepting_this_offerX_you_a_ELL,
  TXTCLI_Decline,
  TXTCLI_More_information,
  TXTMOB_ExpiresX,
  TXTWCL_Claim_your_N0_Bonus,
  TXTWCL_Eligible_Games,
  TXTWCL_Maximum_BetX,
  TXTWCL_Maximum_winX
} from './InstantBonus.SplitWager.messages.json';

const i18nTags = {
  title: {
    tag: TXTWCL_Claim_your_N0_Bonus,
    values: { 0: 'bonusName' }
  },
  maxWinnings: { tag: TXTWCL_Maximum_winX },
  maxBet: { tag: TXTWCL_Maximum_BetX },
  eligibleGames: { tag: TXTWCL_Eligible_Games },
  expires: { tag: TXTMOB_ExpiresX },
  accept: { tag: TXTCLI_Accept },
  decline: { tag: TXTCLI_Decline },
  moreInfo: { tag: TXTCLI_More_information },
  terms: { tag: TXTCLI_By_accepting_this_offerX_you_a_ELL }
};
/**
 * Configuration of different Notification types.
 * {
 *  view - React View to use to display this notification type.
 *  title - i18n string to use for title.
 *  defaultHeaderImageURL - default header image for this notification type.
 *  displayAttributes - The attribute to be displayed on the View.
 *  actions - Buttons to display on the view & associated custom actions.
 * }
 */

const processBonus = (attributes: ActionParams['attributes'], acceptBonus: boolean) => {
  const {
    userRollId,
    notificationId,
    rollState = 1
  } = attributes as SplitWagerBonusMPNotification['attributes'];
  const acceptMsg = {
    acceptBonus,
    rollId: userRollId,
    status: rollState,
    notificationId
  };
  dispatch.notification.acceptBonus(acceptMsg);
  dispatch.modal.close('/mpnotifications');
};

export default {
  front: {
    view: InstantBonusFront,
    viewConfig: {
      title: i18nTags.title,
      defaultHeaderImageURL: defaultHeaderImg,
      moreInfoLabel: i18nTags.terms,
      showCloseIcon: true,
      displayAttributes: [
        {
          attrKey: 'gameMaxBet',
          attrFormatKey: 'currencyCode',
          attrLabel: i18nTags.maxBet,
          attrFormatterType: FormatType.Currency
        },
        {
          attrKey: 'maxWinnings',
          attrFormatKey: 'currencyCode',
          attrLabel: i18nTags.maxWinnings,
          attrFormatterType: FormatType.Currency
        },
        {
          attrKey: 'expiryDate',
          attrLabel: i18nTags.expires,
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: i18nTags.accept,
          actionFunction: ({ attributes }: ActionParams) => processBonus(attributes, true)
        },
        {
          actionType: ActionType.Secondary,
          actionLabel: i18nTags.decline,
          actionFunction: ({ attributes }: ActionParams) => processBonus(attributes, false)
        }
      ]
    }
  },
  back: {
    view: InstantBonusBack,
    viewConfig: {
      title: i18nTags.eligibleGames
    }
  }
};
